import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initNativeApp, isNativeApp } from './lib/native';
import { iniciarInstalacionWeb } from './lib/instalarWeb';

initNativeApp();
if (!isNativeApp()) iniciarInstalacionWeb();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><App/></React.StrictMode>
);
